import { computed, type MaybeRef, unref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useApi } from "@shopexperts/shared";
import type { AdminWalletStatisticsOverview } from "@shopexperts/legacy-api";

interface UseAdminWalletStatisticsOptions {
  currency?: MaybeRef<string | undefined>;
  topLimit?: number;
  enabled?: MaybeRef<boolean>;
}

export function useAdminWalletStatistics(options: UseAdminWalletStatisticsOptions = {}) {
  const api = useApi();
  const enabled = computed(() => unref(options.enabled) ?? true);
  const currency = computed(() => unref(options.currency));

  const query = useQuery({
    queryKey: computed(() => ["admin", "wallet", "statistics", currency.value ?? null]),
    queryFn: () =>
      api.admin.wallet.getWalletStatistics({
        query: {
          ...(currency.value ? { currency: currency.value } : {}),
          ...(options.topLimit ? { top_limit: options.topLimit } : {}),
        },
      }),
    enabled,
    staleTime: 60_000,
    gcTime: 5 * 60_000,
  });

  const statistics = computed<AdminWalletStatisticsOverview | undefined>(() => query.data.value);

  return {
    statistics,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
